// extracted by mini-css-extract-plugin
module.exports = {"upper":"Upper_upper__Kry8S","upperButton":"Upper_upper-button__28nyO","upperButtonActive":"Upper_upper-button-active__FpnAs","upperButtonInner":"Upper_upper-button-inner__TjU__"};